import { apiClient } from './api';
import { Configuration, ConfigurationGroup, UpdateConfigurationRequest } from '../types/api';

export const configurationService = {
  getAll: async (): Promise<ConfigurationGroup[]> => {
    const { data } = await apiClient.get('/configuration');
    return data;
  },

  getByKey: async (key: string): Promise<Configuration> => {
    const { data } = await apiClient.get(`/configuration/${key}`);
    return data;
  },

  update: async (key: string, request: UpdateConfigurationRequest): Promise<void> => {
    await apiClient.put(`/configuration/${key}`, request);
  },
};
